import type { ConversationMemberRead, ConversationRead, UUID } from "../api/types";

export function canUserWriteConversation(params: {
  conversation: ConversationRead | null;
  userId: UUID | null | undefined;
  members: ConversationMemberRead[];
  canViewAll: boolean;
}): boolean {
  const { conversation, userId, members, canViewAll } = params;
  if (!conversation || !userId) return false;
  if (canViewAll || conversation.owner_id === userId) return true;
  return members.some((member) => (
    member.user_id === userId && member.access === "write"
  ));
}
